// @ts-nocheck
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostApi } from "../../../ApiClient/PostApi";
import Header from "../layout/Header";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { Loader2 } from "../../loader/Loader";
export default function ChangePassword() {
  const navigate = useNavigate();
  const [data, setData] = useState({
    confirm_password: "",
    password: "",
    currentPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const onChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState(false);
  const [cpassword, setCpassword] = useState(false);
  function containsUppercase(str) {
    return /[A-Z]/.test(str);
  }
  const change_password = async (event) => {
    event.preventDefault();

    if (data.currentPassword === "") {
      error_toaster("Current Password is required!");
      return false;
    } else if (data.password === "") {
      error_toaster("Password is required!");
      return false;
    } else if (data.password.length < 6) {
      error_toaster("Password must be atleast 6 characters!");
      return false;
    } else if (!containsUppercase(data.password)) {
      error_toaster("Password must contain upper-case letter!");
      return false;
    }

    if (data.confirm_password === "") {
      error_toaster("Confirm Password is required!");
      return false;
    } else {
      setLoading(true);
      const res = await PostApi("users/change_password", {
        password: data.currentPassword,
        new_password: data.password,
        confirm_password: data.confirm_password,
      });

      if (res.data.status === "1") {
        setLoading(false);
        success_toaster(res.data.message);
        navigate("/");
      } else {
        setLoading(false);
        error_toaster(res.data.message);
      }
    }
  };
  const body = "body {background: #FFFFFF !important}";
  const inputStyle =
    "w-full bg-themeGray border-none font-normal sm:text-xl text-lg px-5 py-3 rounded-lg placeholder:text-black placeholder:text-opacity-40 focus:outline-none";
  return (
    <>
      <style>{body}</style>
      <Header />
      <section className="flex items-center h-[100vh]">
        {loading ? (
          <Loader2 />
        ) : (
          <div className="xl:w-1/2 lg:w-3/4 md:w-1/2 sm:w-2/3 w-4/5 mx-auto flex flex-col justify-center gap-y-8">
            <h1 className="font-bold sm:text-5xl text-4xl">Change Password</h1>
            <div className="flex flex-col gap-y-4">
              <div className="relative w-full">
                <input
                  type={visible ? "text" : "password"}
                  onChange={onChange}
                  value={data.currentPassword}
                  name="currentPassword"
                  placeholder="Current Password"
                  className={inputStyle}
                />
                <button
                  onClick={() => setVisible(!visible)}
                  type="button"
                  className="text-black text-opacity-40 absolute right-4 top-1/2 -translate-y-1/2"
                >
                  {visible ? (
                    <AiOutlineEye size={28} />
                  ) : (
                    <AiOutlineEyeInvisible size={28} />
                  )}
                </button>
              </div>

              <div className="relative w-full">
                <input
                  type={password ? "text" : "password"}
                  onChange={onChange}
                  value={data.password}
                  name="password"
                  placeholder="New Password"
                  className={inputStyle}
                />
                <button
                  onClick={() => setPassword(!password)}
                  type="button"
                  className="text-black text-opacity-40 absolute right-4 top-1/2 -translate-y-1/2"
                >
                  {password ? (
                    <AiOutlineEye size={28} />
                  ) : (
                    <AiOutlineEyeInvisible size={28} />
                  )}
                </button>
              </div>
              <div className="relative w-full">
                <input
                  type={cpassword ? "text" : "password"}
                  onChange={onChange}
                  value={data.confirm_password}
                  name="confirm_password"
                  placeholder="Confirm Password"
                  className={inputStyle}
                />
                <button
                  onClick={() => setCpassword(!cpassword)}
                  type="button"
                  className="text-black text-opacity-40 absolute right-4 top-1/2 -translate-y-1/2"
                >
                  {cpassword ? (
                    <AiOutlineEye size={28} />
                  ) : (
                    <AiOutlineEyeInvisible size={28} />
                  )}
                </button>
              </div>
            </div>

            <button
              onClick={change_password}
              className="bg-themeBlue text-white font-medium sm:text-xl text-lg py-3 px-8 rounded-md w-full border border-themeBlue hover:bg-transparent hover:text-themeBlue"
            >
              Submit
            </button>
          </div>
        )}
      </section>
    </>
  );
}
